import { render, staticRenderFns } from "./DefaultInfo.vue?vue&type=template&id=731a523e&scoped=true&"
import script from "./DefaultInfo.vue?vue&type=script&lang=js&"
export * from "./DefaultInfo.vue?vue&type=script&lang=js&"
import style0 from "./DefaultInfo.vue?vue&type=style&index=0&id=731a523e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731a523e",
  null
  
)

export default component.exports